import angular from 'angular';

export default angular.module('cloudService', []);



// WEBPACK FOOTER //
// ./modules/cloudService/cloudService.module.js